import { nextExerciseDetailsActionTypes } from './Constants';
import { exerciseTypeCodesNext } from '../../services/Constants';
import { getScoreData } from './services/Misc';

const initialState = {
	loading: false,
	loadingAnswerRequest: false,
	explanation: {},
	id: null,
	elapsed_time_in_seconds: 0,
	time_estimate_in_seconds: 0,
	questions: [],
	chapter_title: '',
	topic_title: '',
	stream_id: null,
	currentAnsweredQuestionId: null,
	exerciseDone: false,
	exerciseTypes: {
		isDictateType: false,
		isOpenEndedType: false,
		isInYourMindType: false,
		isMultipleChoiceType: false,
		isTheBlanksType: false,
		isOpenMultipleType: false,
		isDictateMultipleType: false,
		isMultipleChoiceMultipleAnswersType: false,
		isAIOpenAnswerType: false,
	},
	typoWords: [],
	correctCount: 0,
	incorrectCount: 0,
	wordsToGo: 0,
	streaks: null,
	aiExplanations: [],
	explanationBtnLoading: false,
	answerData: null,
	checkBtnLoading: false,
	explanationLoading: false,
	personalizedBtnLoading: false,
	personalizedQuestionData: null,
	aiExplanationLoading: false,
	currentRequestId: null,
	userAnswer: null,
	topicExplanation: {},
};

export default function exerciseNextReducer(state = initialState, action) {
	const { type, payload } = action;
	const {
		data,
		exerciseType,
		wordTuples,
		correctCount,
		incorrectCount,
		wordsToGo,
		newExplanation,
		explanation,
		answerData,
		personalizedQuestionData,
		aiExplanation,
		requestId,
		isCheckedByAi,
	} = payload || {};

	const { exercise_answer, streak, is_correct } = data || {};
	const { answer_texts, answer_text, question_id, is_ai_open_answer } = exercise_answer || {};

	switch (type) {
		case nextExerciseDetailsActionTypes.RESUME_EXERCISE_REQUEST:
		case nextExerciseDetailsActionTypes.CREATE_EXERCISE:
			return {
				...state,
				loading: true,
			};

		case nextExerciseDetailsActionTypes.GET_QUESTION_EXPLANATION:
			return {
				...state,
				explanationLoading: true,
				aiExplanations: [],
				explanation: {},
			};

		case nextExerciseDetailsActionTypes.GET_QUESTION_EXPLANATION_SUCCESS:
			const { ai_explanation } = explanation || {};

			return {
				...state,
				explanation: { ...explanation },
				aiExplanations: ai_explanation ? [`<p>${ai_explanation}</p>`] : [],
				explanationLoading: false,
			};

		case nextExerciseDetailsActionTypes.GET_QUESTION_EXPLANATION_ERROR:
			return {
				...state,
				explanation: {},
				aiExplanations: [],
				explanationLoading: false,
			};

		case nextExerciseDetailsActionTypes.GET_TOPIC_EXPLANATION:
			return {
				...state,
				explanationLoading: true,
				topicExplanation: {},
			};

		case nextExerciseDetailsActionTypes.GET_TOPIC_EXPLANATION_SUCCESS:
			return {
				...state,
				topicExplanation: data,
				explanationLoading: false,
			};

		case nextExerciseDetailsActionTypes.GET_TOPIC_EXPLANATION_ERROR:
			return {
				...state,
				topicExplanation: {},
				explanationLoading: false,
			};

		case nextExerciseDetailsActionTypes.SEND_QUESTION_ANSWER_REQUEST:
			return {
				...state,
				typoWords: [],
				loading: true,
				loadingAnswerRequest: true,
				explanationBtnLoading: false,
				checkBtnLoading: is_ai_open_answer,
				userAnswer: answer_text || answer_texts,
				answerData: null,
				...(isCheckedByAi ? { requestId: question_id } : {}),
			};

		case nextExerciseDetailsActionTypes.SEND_QUESTION_ANSWER_SUCCESS:
			return {
				...state,
				...(is_ai_open_answer ? { answerData: { is_correct } } : {}),
				loading: false,
				loadingAnswerRequest: false,
				checkBtnLoading: false,
				streaks: streak,
			};

		case nextExerciseDetailsActionTypes.SEND_QUESTION_ANSWER_ERROR:
			return {
				...state,
				loading: false,
				loadingAnswerRequest: false,
			};

		case nextExerciseDetailsActionTypes.CREATE_EXERCISE_SUCCESS:
			const { correct, incorrect, wordsLeft } = getScoreData(data.questions);

			return {
				...state,
				...data,
				correctCount: correct,
				incorrectCount: incorrect,
				wordsToGo: wordsLeft.length,
			};

		case nextExerciseDetailsActionTypes.RESUME_EXERCISE_SUCCESS:
			return {
				...state,
				...data,
			};

		case nextExerciseDetailsActionTypes.GET_ADDITIONAL_EXPLANATION_REQUEST:
			return {
				...state,
				explanationBtnLoading: true,
			};

		case nextExerciseDetailsActionTypes.GET_ADDITIONAL_EXPLANATION_SUCCESS:
			return {
				...state,
				aiExplanations: [...state.aiExplanations, `<p>${newExplanation}</p>`],
				explanationBtnLoading: false,
			};

		case nextExerciseDetailsActionTypes.CHECK_ANSWER_REQUEST:
			return {
				...state,
				checkBtnLoading: true,
			};

		case nextExerciseDetailsActionTypes.CHECK_ANSWER_SUCCESS:
			return {
				...state,
				answerData,
				checkBtnLoading: false,
				aiExplanations: answerData.explanation ? [answerData.explanation] : [],
			};

		case nextExerciseDetailsActionTypes.CHECK_ANSWER_ERROR:
			return {
				...state,
				checkBtnLoading: false,
			};

		case nextExerciseDetailsActionTypes.PERSONALIZED_QUESTION_REQUEST:
			return {
				...state,
				personalizedBtnLoading: true,
			};

		case nextExerciseDetailsActionTypes.PERSONALIZED_QUESTION_SUCCESS:
			return {
				...state,
				personalizedBtnLoading: false,
				personalizedQuestionData,
			};

		case nextExerciseDetailsActionTypes.PERSONALIZED_QUESTION_ERROR:
			return {
				...state,
				personalizedBtnLoading: false,
			};

		case nextExerciseDetailsActionTypes.CLEAR_STATE:
			return initialState;

		case nextExerciseDetailsActionTypes.CLEAR_EXPLANATION:
			return {
				...state,
				explanation: {},
			};

		case nextExerciseDetailsActionTypes.SET_EXERCISE_SCORE:
			return {
				...state,
				correctCount,
				incorrectCount,
				wordsToGo,
			};

		case nextExerciseDetailsActionTypes.SET_FINISH_EXERCISE:
			return {
				...state,
				exerciseDone: true,
			};

		case nextExerciseDetailsActionTypes.CHECK_WORDS_BY_TYPO:
			return {
				...state,
				typoWords: [],
			};

		case nextExerciseDetailsActionTypes.CHECK_WORDS_BY_TYPO_SUCCESS:
			return {
				...state,
				typoWords: wordTuples,
			};

		case nextExerciseDetailsActionTypes.HANDLE_NEXT_EXERCISE_TYPES:
			return {
				...state,
				exerciseTypes: {
					isDictateType: exerciseTypeCodesNext.DICTATE === exerciseType,
					isOpenEndedType: exerciseTypeCodesNext.OPEN_ENDED === exerciseType,
					isInYourMindType: exerciseTypeCodesNext.IN_YOUR_MIND === exerciseType,
					isMultipleChoiceType: exerciseTypeCodesNext.MULTIPLE_CHOICE === exerciseType,
					isTheBlanksType: exerciseTypeCodesNext.THE_BLANKS === exerciseType,
					isOpenMultipleType: exerciseTypeCodesNext.OPEN_MULTIPLE === exerciseType,
					isDictateMultipleType: exerciseTypeCodesNext.DICTATE_MULTIPLE === exerciseType,
					isMultipleChoiceMultipleAnswersType:
						exerciseTypeCodesNext.MULTIPLE_CHOICE_MULTIPLE_ANSWERS === exerciseType,
					isMatchingType: exerciseTypeCodesNext.MATCHING === exerciseType,
					isAIOpenAnswerType: exerciseTypeCodesNext.AI_OPEN_ANSWER === exerciseType,
				},
				aiExplanations: [],
				answerData: null,
			};

		case nextExerciseDetailsActionTypes.SET_REQUEST_ID:
			return {
				...state,
				currentRequestId: requestId,
			};

		case nextExerciseDetailsActionTypes.GET_AI_EXPLANATION_REQUEST:
			return {
				...state,
				aiExplanationLoading: true,
				aiExplanations: [],
				currentRequestId: null,
			};

		case nextExerciseDetailsActionTypes.GET_AI_EXPLANATION_SUCCESS:
			return {
				...state,
				aiExplanations:
					aiExplanation && requestId === state.currentRequestId
						? [`<p>${aiExplanation}</p>`]
						: [],
				aiExplanationLoading: false,
			};

		case nextExerciseDetailsActionTypes.GET_AI_EXPLANATION_ERROR:
			return {
				...state,
				aiExplanationLoading: false,
				aiExplanations: [],
			};

		case nextExerciseDetailsActionTypes.RESUME_EXERCISE_ERROR:
		case nextExerciseDetailsActionTypes.CREATE_EXERCISE_ERROR:
		case nextExerciseDetailsActionTypes.STOP_TEST_ERROR:
		case nextExerciseDetailsActionTypes.STORE_ERROR:
			return {
				...state,
				loading: false,
			};

		default:
			return state;
	}
}
